import { useEffect, useState } from "react";
import { Phone, Mail } from "lucide-react";

const WHATSAPP_NUMBER = "393473188828"; // international format, no +
const TEL_NUMBER = "+393473188828";
const WHATSAPP_DISPLAY = "+39 347 318 8828";
const EMAIL = "napolitanomaxagency@live.com";

export default function DirectorContact({ variant = "band" }) {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const check = () =>
      setIsMobile(
        typeof window !== "undefined" &&
          window.matchMedia("(max-width: 767px)").matches
      );
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const waHref = `https://wa.me/${WHATSAPP_NUMBER}`;
  const telHref = `tel:${TEL_NUMBER}`;
  const primaryHref = isMobile ? telHref : waHref;
  const mailHref = `mailto:${EMAIL}?subject=${encodeURIComponent(
    "Richiesta contatto — NMA Agency"
  )}`;

  if (variant === "compact") {
    return (
      <div
        className="flex flex-wrap items-center gap-3"
        data-testid="director-contact-compact"
      >
        <a
          href={primaryHref}
          target={isMobile ? "_self" : "_blank"}
          rel="noopener noreferrer"
          className="av-pill av-pill-gold"
          data-testid="director-whatsapp-btn"
        >
          <Phone size={16} />{" "}
          {isMobile ? `Chiama ${WHATSAPP_DISPLAY}` : `WhatsApp ${WHATSAPP_DISPLAY}`}
        </a>
        <a
          href={mailHref}
          className="av-pill av-pill-ghost"
          data-testid="director-email-btn"
        >
          <Mail size={16} /> {EMAIL}
        </a>
      </div>
    );
  }

  return (
    <section
      className="border-y av-hairline bg-[#141210]/70"
      data-testid="director-contact-band"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid md:grid-cols-2 gap-8 items-center">
        <div>
          <span className="av-eyebrow" data-testid="director-eyebrow">
            Contatto diretto
          </span>
          <h2 className="font-serif-display text-3xl sm:text-4xl mt-3 leading-tight">
            Direttore{" "}
            <span className="italic text-[#E5A93C]">
              Massimiliano Napolitano
            </span>
          </h2>
          <p className="text-[#A39E93] mt-3 text-sm sm:text-base max-w-xl">
            Parla direttamente con la direzione NMA Agency. Da mobile parte
            subito la chiamata classica; da desktop apre WhatsApp Business.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 md:justify-end">
          <a
            href={primaryHref}
            target={isMobile ? "_self" : "_blank"}
            rel="noopener noreferrer"
            className="av-pill av-pill-gold justify-center text-base py-4 px-6"
            data-testid="director-whatsapp-btn"
            aria-label={
              isMobile
                ? `Chiama ${WHATSAPP_DISPLAY}`
                : `WhatsApp Business ${WHATSAPP_DISPLAY}`
            }
          >
            <Phone size={18} />
            <span className="flex flex-col items-start leading-tight">
              <span className="text-[10px] uppercase tracking-widest opacity-80">
                {isMobile ? "Chiamata diretta" : "WhatsApp Business"}
              </span>
              <span className="font-mono">{WHATSAPP_DISPLAY}</span>
            </span>
          </a>
          <a
            href={mailHref}
            className="av-pill av-pill-ghost justify-center text-base py-4 px-6"
            data-testid="director-email-btn"
            aria-label={`Invia email a ${EMAIL}`}
          >
            <Mail size={18} />
            <span className="flex flex-col items-start leading-tight">
              <span className="text-[10px] uppercase tracking-widest opacity-80">
                Email diretta
              </span>
              <span>{EMAIL}</span>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
